import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import BuzzImage from '../../../../../components/BuzzImage/BuzzImage';
import CustomCheckBox from '../../../../../components/CheckBox/CheckBox';

function AboutDetails({ styles, data }) {
  const { schoolData, schoolClasses } = useSelector((state) => {
    const { approvalManagementReducer } = state;
    return {
      schoolData: approvalManagementReducer && approvalManagementReducer.data,
      schoolClasses:
        approvalManagementReducer && approvalManagementReducer.schoolClasses,
    };
  });

  return (
    <div>
      {data ? (
        <Grid item xs={12}>
          <div className={styles.sectionContainer}>
            <div className={styles.section}>
              <div className={styles.imageContainer}>
                {schoolData && schoolData.bannerImageUrl && (
                  <BuzzImage
                    src={schoolData.bannerFullUrl}
                    alt="banner"
                    className={styles.bannerImage}
                  />
                )}
              </div>
              <div className={styles.branchTextContainer}>
                <p>Branch-ID: {data.branchId}</p>
                <p>{data.schoolName}</p>
              </div>
            </div>
            {schoolClasses && (
              <>
                <div className={styles.solidBorderBottom}></div>
                <Box>
                  <div className={styles.section}>
                    <p>School Admission Status</p>
                    <p className={styles.subHeadingText}>
                      Indicate which classes are open for admission
                    </p>
                  </div>
                  <div className={styles.dashedBorderBottomNoPadd}></div>
                  {/* CHECKBOXES */}
                  <div className={styles.section}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          flexGrow: 1,
                        }}>
                        {schoolClasses &&
                          schoolClasses.map((data, idx) => (
                            <Box key={idx} width={170}>
                              <CustomCheckBox item={data} />
                            </Box>
                          ))}
                      </Box>
                    </Box>
                  </div>
                </Box>
              </>
            )}
          </div>

          {/* BRANCH DETAILS */}
          <div className={styles.sectionContainer}>
            <div className={styles.section}>
              <div className={styles.subSection}>
                <p className={styles.sectionText}>Branch Details</p>
                <div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Founded in</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.foundedIn}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>For classes</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.forClass}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Type of School</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.typeOfSchool}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Organization Type</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.ownershipType}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Social Link</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.socialLink}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                </div>
              </div>
            </div>

            <div className={styles.section}>
              <div className={styles.subSection}>
                <p className={styles.sectionText}>Contacts details</p>
                <div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Contact no.</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.contactNo}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>E-mail ID</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.email}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Address</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.address}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>City</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.city}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>State</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.state}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Postal Code</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.pincode}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                </div>
              </div>
            </div>
          </div>
          {/* ABOUT SCHOOL */}
          <div className={styles.sectionContainer}>
            <div className={styles.section}>
              <div className={styles.subSection}>
                <p className={styles.sectionText}>About School</p>
                <p className={styles.sectionSubTextNoWeight}>{data.about}</p>
              </div>
            </div>
          </div>
        </Grid>
      ) : null}
    </div>
  );
}

export default AboutDetails;
